export class HelperService {
  constructor() {
  }

  public static wait(ms): Promise<any> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public static sortBy(array, fields) {
    const sortFields = Array.isArray(fields) ? fields : [fields];
    return array.slice().sort((a, b) => {
      for (const field of sortFields) {
        const valA = field === 'order' ? a[field] ? parseInt(a[field]) : Infinity : a[field];
        const valB = field === 'order' ? b[field] ? parseInt(b[field]) : Infinity : b[field];
        if (valA < valB) return -1;
        if (valA > valB) return 1;
      }
      return 0;
    });
  }

  public static initOpeningData(data) {
    try {
      const raw = JSON.parse(data.raw);
      if (raw?.openingInfo?.length && raw?.openingInfo?.length > data?.openingInfo?.length) {
        data.openingInfo = raw.openingInfo;
      }
    } catch (err) {}
    if (!data?.openingInfo?.length) {
      return null;
    }

    data.openingInfo.sort((a, b) => HelperService.getOrder(a) - HelperService.getOrder(b));

    const times = data.openingInfo.filter(el => {
      const startDate = new Date(el.startDate);
      startDate.setHours(23, 59, 59, 999);
      const endDate = new Date(el.endDate);
      endDate.setHours(23, 59, 59, 999);
      return !el.startDate && !el.endDate || (el.endDate && endDate >= new Date()) || (!el.endDate && el.startDate && startDate >= new Date());
    });
    if (times?.length > 0 && !data.openingHours) {
      data.openingHours = { regularOpeningHours: HelperService.getDefaultOpeningHours() };
      data.openingHours.futurePeriod = [];
    }
    let hideMainOpeningHours = false;
    times.forEach(info => {
      if (!info.startDate && !info.endDate) {
        data.openingHours.regularOpeningHours = HelperService.convertOpeningInfo(data.openingHours.regularOpeningHours, info.days);
        data.openingHours.regularOpeningHoursTitle = info.titles;
      } else if (info.startDate && info.endDate && info.startDate !== info.endDate) {
        const openingHours = HelperService.convertPeriodOpeningInfo(data.openingHours.regularOpeningHours, info);
        hideMainOpeningHours = openingHours.hideMainOpeningHours === true ? true : hideMainOpeningHours;
        if (HelperService.checkFuturePeriod(info)) {
          if (!data.openingHours.futurePeriod) {
            data.openingHours.futurePeriod = [];
          }
          data.openingHours.futurePeriod.push(HelperService.checkFuturePeriod(info));
        }
      } else if (info.startDate) {
        const openingHours = HelperService.convertSingleDate(data.openingHours.regularOpeningHours, info);
        Object.assign(data.openingHours, openingHours);
        if (HelperService.checkFutureSingle(info)) {
          if (!data.openingHours.futurePeriod) {
            data.openingHours.futurePeriod = [];
          }
          data.openingHours.futurePeriod.push(HelperService.checkFutureSingle(info));
        }
      }
      data.openingHours.hideMainOpeningHours = hideMainOpeningHours;
    });
    return data.openingHours;
  }

  private static getOrder(obj) {
    return !obj.startDate && !obj.endDate ? 0 : obj.startDate && obj.endDate ? 1 : obj.startDate ? 2 : 3;
  }

  private static getDefaultOpeningHours() {
    return {
      sunday: { open: false }, monday: { open: false }, tuesday: { open: false }, wednesday: { open: false }, thursday: { open: false },
      friday: { open: false }, saturday: { open: false }
    };
  }

  private static checkFutureSingle(openingInfo) {
    const startDate = new Date(openingInfo.startDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let openingHours: any;
    if (startDate >= today) {
      openingHours = {};
      openingHours.titles = HelperService.getTexts(openingInfo.titles);
      openingHours.comment = HelperService.getTexts(openingInfo.comment);
      openingHours.startDate = openingInfo.startDate;
      openingHours.type = 'single';
      openingHours.open = openingInfo.days?.[0]?.open || openingInfo.open;
      openingHours.openFullDay = openingInfo.days?.[0]?.openFullDay || openingInfo.openFullDay;
      openingInfo.times = openingInfo.days?.[0]?.times || openingInfo.times;
      openingHours.times = this.checkTimes(openingInfo.times);
    }
    return openingHours;
  }

  private static checkFuturePeriod(openingInfo) {
    const endDate = new Date(openingInfo.endDate);
    const startDate = new Date(openingInfo.startDate);
    const today = new Date();
    const todayCopy = new Date();
    today.setHours(0, 0, 0, 0);
    todayCopy.setHours(0, 0, 0, 0);
    const sixMonthDate = new Date(todayCopy.setMonth(todayCopy.getMonth() + 6));
    let openingHours: any;
    if ((endDate > today) && (startDate < sixMonthDate)) {
      openingHours = {};
      openingHours.titles = HelperService.getTexts(openingInfo.titles);
      openingHours.comment = HelperService.getTexts(openingInfo.comment);
      openingHours.startDate = openingInfo.startDate;
      openingHours.endDate = openingInfo.endDate;
      openingHours.type = 'period';
      openingHours.days = {};
      for (let i = 0; i < openingInfo.days.length; i++) {
        openingHours.days[openingInfo.days[i].day] = {
          open: openingInfo.days[i].open, openFullDay: openingInfo.days[i].openFullDay,
          times: this.checkTimes(openingInfo.days[i].times)
        }
      }
    }
    return openingHours;
  }

  private static getTexts(data) {
    return (Array.isArray(data) && data.length) ? data : Object.keys(data || {}).length ? Object.keys(data || {}).map(key => {
      return { language: key, title: data[key] }
    }) : undefined;
  }

  private static convertOpeningInfo(openingHours, openingInfo) {
    for (let i = 0; i < openingInfo.length; i++) {
      if (!openingHours) {
        openingHours = {};
      }
      openingHours[openingInfo[i].day] = { open: openingInfo[i].open, openFullDay: openingInfo[i].openFullDay, times: this.checkTimes(openingInfo[i].times) }
    }
    return openingHours;
  }

  private static convertPeriodOpeningInfo(openingHours, openingInfo) {
    const startDate = new Date(openingInfo.startDate);
    startDate.setHours(0, 0, 0, 0);
    const endDate = new Date(openingInfo.endDate);
    endDate.setHours(23, 59, 59, 999);
    let nextOpenDay;
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    const weekdays = { 0: 'sunday', 1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday' };
    let hideMainOpeningHours = false;
    for (let i = 0; i < 8; i++) {
      if (startDate <= HelperService.getWeekDay(date, i) && HelperService.getWeekDay(date, i) <= endDate) {
        const dayInfo = openingInfo.days.find(el => el.day === weekdays[i === 7 ? 0 : i]);
        if (dayInfo) {
          const index = (dayInfo && i === 7 && JSON.stringify(openingHours[weekdays[0]]) !== JSON.stringify({
            open: dayInfo.open, times: this.checkTimes(dayInfo.times)
          })) ? 0 : i;
          if (weekdays[index]) {
            openingHours[weekdays[index]] = { open: dayInfo.open, times: this.checkTimes(dayInfo.times) };
          }
        }
        hideMainOpeningHours = true;
      }
    }
    nextOpenDay = HelperService.getNextOpenDate(openingInfo);
    return { openingHours, nextOpenDay, hideMainOpeningHours };
  }

  private static getNextOpenDate(openingInfo) {
    const weekdays = { 0: 'sunday', 1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday' };
    let nextOpenDayInfo;
    const startDate = new Date(openingInfo.startDate);
    const startDateCopy = new Date(openingInfo.startDate);
    const endDate = new Date(openingInfo.endDate)
    for (let i = 0; i < 7; i++) {
      const searchDate = new Date(startDateCopy.setDate(startDate.getDate() + i));
      const searchDayInfo = openingInfo.days.find(el => el.day === weekdays[searchDate.getDay()]);
      if (searchDayInfo && searchDayInfo.open) {
        const nextOpenDay = HelperService.getNextDayOfWeek(searchDate.getDay());
        if (nextOpenDay <= endDate) {
          nextOpenDayInfo = {
            date: nextOpenDay.toISOString(), open: true, times: this.checkTimes(searchDayInfo.times), type: 'openingInfo'
          };
          break;
        }
      }
    }
    return nextOpenDayInfo;
  }

  private static getNextDayOfWeek(targetDay) {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const daysUntilTarget = (targetDay - dayOfWeek + 7) % 7;
    const nextDate = new Date(today);
    nextDate.setDate(today.getDate() + daysUntilTarget);

    return nextDate;
  }

  private static getWeekDay(date, dayNumber) {
    const day = date.getDay();
    return new Date(date.setDate(date.getDate() - day + dayNumber));
  }

  private static convertSingleDate(openingHours, openingInfo) {
    const startDate = new Date(openingInfo.startDate);
    let nextOpenDay: any;
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    if (startDate > HelperService.getWeekDay(date, 0) && startDate < HelperService.getWeekDay(date, 6)) {
      nextOpenDay = { date: openingInfo.startDate, open: openingInfo.open, times: this.checkTimes(openingInfo.times), type: 'openingInfo' };
    } else if (startDate > HelperService.getWeekDay(date, 6) && openingInfo.open) {
      nextOpenDay = { date: openingInfo.startDate, open: true, times: this.checkTimes(openingInfo.times), type: 'openingInfo' };
    }
    return { openingHours, nextOpenDay };
  }

  private static checkTimes(times) {
    return (times || []).map(el => {
      return el;
    });
  }

  public static setEmptyStringsToNull(obj) {
    for (const key in obj) {
      if (typeof obj[key] === 'string' && obj[key].trim() === '') {
        obj[key] = null;
      }
    }
    return obj;
  }

  public static buildMonitorUrl(iframeUrl) {
    const getParam = (param) => this.getUrlParameterValue(iframeUrl, param);

    let stationIds = [];
    let stationQuantities = [];
    let showClock = null;

    const stationsParam = getParam('stations');
    if (stationsParam) {
      try {
        const stations = JSON.parse(decodeURIComponent(stationsParam));
        stationIds = stations.map(s => this.formatStationId(s.stationId));
        stationQuantities = stations.map(s => s.quantity || 1);
      } catch (e) {
        console.error('Failed to parse stations JSON', e);
      }
      const clockType = getParam('clockType');
      if (clockType && clockType !== '"noClock"') {
        showClock = clockType;
      }
    } else {
      stationIds = [1, 2].map(i => this.formatStationId(getParam(`station_${i}_id`)));
      stationQuantities = [1, 2].map(i => getParam(`station_${i}_quantity`));
      showClock = getParam('showClock');
    }

    let url = 'https://ibex3.ibexfusion.com/oev/monitor.php';
    if (stationIds[0]) url = this.appendParam(url, 'station', stationIds[0]);
    if (stationQuantities[0]) url = this.appendParam(url, 'station1_quantity', stationQuantities[0]);
    if (stationIds[1]) url = this.appendParam(url, 'station2', stationIds[1]);
    if (stationQuantities[1]) url = this.appendParam(url, 'station2_quantity', stationQuantities[1]);
    if (showClock) url = this.appendParam(url, 'showClock', showClock);

    return url;
  }

  public static async delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public static parseJSON<T = any>(raw: string): T {
    try {
      return JSON.parse(raw);
    } catch {
      return {} as T;
    }
  }

  private static formatStationId(id) {
    if (!id || !id.includes(':')) return id;
    return id.replace(':', id.length === 7 ? '0' : '');
  }

  private static appendParam(url, key, value) {
    if (!value) return url;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${key}=${value}`;
  }

  private static getUrlParameterValue(url, paramName) {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.searchParams.get(paramName);
    } catch (error) {
      return url;
    }
  }

  public static async allSettled<T>(promises: Promise<T>[]): Promise<{ status: string, value?: T, reason?: any }[]> {
    return Promise.all(promises.map(p => p.then(value => ({ status: 'fulfilled', value }), reason => ({ status: 'rejected', reason }))));
  }
}
